/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useCallback, useMemo, memo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {Link, useHistory} from "react-router-dom";
import * as Actions from "actions";
import {
  Card, IconButton, Box, Typography, Button,
} from "@mui/material";
import {getImage, getURI, getPrice, isAddCartAllowed} from "helpers/utils";
import CircularProgress from '@mui/material/CircularProgress';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';



import "./ShopProductItem.scss";
import HoverBox from "components/HoverBox";
import LazyImage from "components/LazyImage";
import {FlexBetween, FlexBox} from "components/flex-box";
import { H2, H6 } from "components/CustomTypography";
import BazaarButton from "components/BazaarButton";
import {AddBox, Favorite} from "@mui/icons-material";
import ArrowRight from "@mui/icons-material/ArrowRight";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';


const ShopProductItem = memo((props) => {
  const [state, setState] = useState({
    open: false,
    stock: "InStock",
    quantity: 1,
    image: "",
  });

  const history = useHistory();

  const {
    product, onBottomClick, onMainClick, onArrowClick, onAddToCartClicked, onAddToWishlistClicked,
    isDirect, currency, shopId, inCart, isCartLoading,
    cartAddingPid, linkMain, linkArrow,
  } = props;

  // Memoize expensive calculations
  const productImage = useMemo(() => getImage(product.images), [product.images]);
  const productPrice = useMemo(() => getPrice(product, currency), [product, currency]);

  // Memoize static URLs to prevent recreation on each render
  const iconUrls = useMemo(() => ({
    veg: `${process.env.PUBLIC_URL}/assets/images/GreenIcon.png`,
    nonVeg: `${process.env.PUBLIC_URL}/assets/images/RedIcon.png`,
  }), []);

  const handleLinkMainClick = () => {
    if (linkMain) {
      history.push(`${linkMain}`);
    } else {
      const productId = product.id || product.product_id;
      history.push(getURI(process.env.REACT_APP_TYPE, "shop_product", shopId, productId, ""));
    }
  };

  const handleLinkArrowClick = () => {
    if (linkArrow) {
      history.push(`${linkArrow}`);
    } else {
      const productId = product.id || product.product_id;
      history.push(getURI(process.env.REACT_APP_TYPE, "shop_product", shopId, productId, ""));
    }
  };

  return (
      <Box pb={3} pl={1} pr={1}
           sx={{
             position: 'relative', // Needed to anchor the arrow inside this box
           }}>
        <HoverBox  mb={0} mx="auto" borderRadius="2px" onClick={isDirect ? handleLinkMainClick : onMainClick}>
          <LazyImage
              src={productImage}
              width="100%"
              alt={product.name}
              mx="auto"
          />
        </HoverBox>
        <FlexBetween mt={0} onClick={isDirect ? handleLinkMainClick : onBottomClick}>
            <Box width="10%" noWrap sx={{ overflow: 'hidden' }}>
                <ArrowRight fontSize="small" color="primary" />
            </Box>
          <Box width="70%" noWrap sx={{ overflow: 'hidden' }}>
            <H2 fontSize={14} width="100%" textAlign="left" title={product.name} >
                {productPrice}
            </H2>
            <FlexBox alignItems="center">
              <H6 fontSize={10} textTransform="capitalize" textAlign="left" ellipsis>
                  {product.name}
              </H6>
            </FlexBox>
          </Box>

          <Box width="20%">
              {isAddCartAllowed(product) &&
                  (inCart ?
                          <ShoppingCartIcon color="primary" />
                          :
                      (isCartLoading && cartAddingPid === (product.id || product.product_id) ?
                              <CircularProgress size="1rem"/>
                              :
                          <BazaarButton
                              color="primary"
                              disableRipple
                              disableElevation
                              onClick={onAddToCartClicked}
                              sx={{
                                  height: "0",
                                  alignItems: "flex-start",
                                  "&:hover": {
                                      backgroundColor: "transparent",
                                  },
                              }}
                          >
                              <AddBox color="primary" fontSize="medium"/>
                          </BazaarButton>
                      )
                  )
              }
          </Box>
        </FlexBetween>
        <IconButton
            onClick={isDirect ? handleLinkArrowClick : onArrowClick}
            sx={{
              position: 'absolute',
              bottom: 60,
              right: 8,
              backgroundColor: 'white',
              color: 'primary.main',
              width: 16,
              height: 16,
              zIndex: 1,
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
        >
          <PlayCircleIcon fontSize="medium" />
        </IconButton>
      </Box>
  );
});

// Add display name for debugging
ShopProductItem.displayName = 'ShopProductItem';

ShopProductItem.defaultProps = {
    currency: 'USD',
    isDirect: false,
    linkMain: null,
    linkArrow: null,
};

ShopProductItem.propTypes = {
    currency: PropTypes.string,
    product: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      product_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      images: PropTypes.array,
      name: PropTypes.string,
    }).isRequired,
  onBottomClick: PropTypes.func,
  onMainClick: PropTypes.func,
  onArrowClick: PropTypes.func,
  onAddToCartClicked: PropTypes.func.isRequired,
  onAddToWishlistClicked: PropTypes.func.isRequired,
  isDirect: PropTypes.bool,
  linkMain: PropTypes.string,
  linkArrow: PropTypes.string,
  shopId: PropTypes.string,
  inCart: PropTypes.bool,
  isCartLoading: PropTypes.bool,
  cartAddingPid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

// Optimize Redux connection with shallow equality check
const mapStateToProps = ({ userproducts, bootupInfo }) => ({
  bootupInfo,
  currency: bootupInfo.symbol,
  reqStatus: userproducts.reqStatus,
  isLoading: userproducts.isLoading,
  serviceError: userproducts.serviceError,
  productprices: userproducts.productprices,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...Actions }, dispatch);

// Use React.memo with custom comparison function for better performance
const areEqual = (prevProps, nextProps) => {
  const prevId = prevProps.product.id || prevProps.product.product_id;
  const nextId = nextProps.product.id || nextProps.product.product_id;
  
  // Only re-render if product data, currency, or key props change
  return (
    prevId === nextId &&
    prevProps.currency === nextProps.currency &&
    prevProps.isDirect === nextProps.isDirect &&
    prevProps.linkMain === nextProps.linkMain &&
    prevProps.inCart === nextProps.inCart &&
    prevProps.isCartLoading === nextProps.isCartLoading &&
    JSON.stringify(prevProps.product.images) === JSON.stringify(nextProps.product.images)
  );
};

const MemoizedShopProductItem = memo(ShopProductItem, areEqual);

const ShopProductItemComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MemoizedShopProductItem);

export default ShopProductItemComponent;
